import React, { Component } from 'react';
import {Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { withFirebase } from '../../components/Firebase';
import * as ROUTES from '../../constants/routes';
import { SignInLink } from '../SignIn';

//import {Link as LinkUI} from '@material-ui/core/Link';
import { Link as LinkUI } from '@material-ui/core';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
//import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';


export default function SignUpPage () {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        <SignUpForm classes={classes}/>
      </div>
      <Box mt={5}>
        
      </Box>
    </Container>
  )
};


const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  passwordOne: '',
  passwordTwo: '',
  error: null,
  buttonText: "Sign Up",
  agree: false,
};

class SignUpFormBase extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    this.setState({ error :null});
    this.setState({ buttonText :"Loading..."});
    this.props.firebase.doSetPersistence("session").then(()=>{
      const { firstName, lastName, email, passwordOne } = this.state;
      const username=lastName !== "" ? firstName+" "+lastName : firstName;
      this.props.firebase
        .doCreateUserWithEmailAndPassword(email, passwordOne)
        .then(authUser => {
          // Create a user in your Firebase realtime database
          /*return this.props.firebase
            .user(authUser.user.uid)
            .set({
              username,
              email,
            });*/
            
          return this.props.firebase.fs.collection("users").doc(authUser.user.uid).set({
            id: authUser.user.uid,
            name: username,
            email: email,
            phone: "",
            gender: "",
            photoURL:"",
            //companyId: "",
            //branchId: "",
          
          })
        })
        .then(() => {
          this.setState({ ...INITIAL_STATE });
          this.props.history.push(ROUTES.HOME);
        })
        .catch(error => {
          this.setState({ error });
          this.setState({ buttonText :"Sign Up"});
        });
      }).catch(error=>{
        this.setState({ error });
          this.setState({ buttonText :"Sign Up"});
      })
    //event.preventDefault();
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  onAgree = event => {
    this.setState({ agree: event.target.checked });
  };

  render() {
    const {
      firstName,
      lastName,
      //username,
      email,
      passwordOne,
      passwordTwo,
      error,
      buttonText,
      agree,
    } = this.state;

    const isInvalid =
      !agree ||
      passwordOne !== passwordTwo ||
      passwordOne === '' ||
      email === '' ||
      firstName === ''
      ;

    return (

        <div className={this.props.classes.form} >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="firstName"
                value={firstName}
                onChange={this.onChange}
                variant="outlined"
                required
                fullWidth
                id="firstName"
                label="First Name"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                value={lastName}
                onChange={this.onChange}
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                value={email}
                onChange={this.onChange}
                autoComplete="email"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="passwordOne"
                value={passwordOne}
                onChange={this.onChange}
                label="Password"
                type="password"
                id="passwordOne"
                autoComplete="current-password"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="passwordTwo"
                value={passwordTwo}
                onChange={this.onChange}
                label="Confirm Password"
                type="password"
                id="passwordTwo"
                autoComplete="current-password"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={<Checkbox value="agree" color="primary" checked={agree} onChange={this.onAgree}/>}
                label={<>I agree to the <LinkUI href="/terms" target="_blank" rel="noopener">Terms</LinkUI> and <LinkUI href="/privacy" target="_blank" rel="noopener">Privacy Policy</LinkUI></>}
                
              />
              
            </Grid>
          </Grid>
          <Button
            type="submit"
            onClick={this.onSubmit}
            fullWidth
            variant="contained"
            color="primary"
            className={this.props.classes.submit}
            disabled={isInvalid}
          >
            {buttonText}
          </Button>
          {error && <p>{error.message}</p>}
          <Grid container justify="flex-end">
            <Grid item>
              
              <SignInLink />
              
            </Grid>
          </Grid>
        </div>



      /*
      <form onSubmit={this.onSubmit}>
        <input
          name="username"
          value={username}
          onChange={this.onChange}
          type="text"
          placeholder="Full Name"
        />
        <input
          name="email"
          value={email}
          onChange={this.onChange}
          type="text"
          placeholder="Email Address"
        />
        <input
          name="passwordOne"
          value={passwordOne}
          onChange={this.onChange}
          type="password"
          placeholder="Password"
        />
        <input
          name="passwordTwo"
          value={passwordTwo}
          onChange={this.onChange}
          type="password"
          placeholder="Confirm Password"
        />
        <button disabled={isInvalid} type="submit">
          Sign Up
        </button>

        {error && <p>{error.message}</p>}
      </form>
      */
    );
  }
}

const SignUpLink = () => (
  <p>
    Don't have an account? <Link to={ROUTES.SIGN_UP}>Sign Up</Link>
  </p>
);

//const SignUpForm = withRouter(withFirebase(SignUpFormBase));
const SignUpForm = compose(
  withRouter,
  withFirebase,
)(SignUpFormBase);

export { SignUpForm, SignUpLink };